export const PAYONEER_GET_EMPLOYEE_REGISTRATION_LINK = "PAYONEER_GET_EMPLOYEE_REGISTRATION_LINK";
export const PAYONEER_SET_EMPLOYEE_REGISTRATION_LINK = "PAYONEER_SET_EMPLOYEE_REGISTRATION_LINK";
export const PAYONEER_GET_EMPLOYEE_REGISTRATION_LINK_FAILED = "PAYONEER_GET_EMPLOYEE_REGISTRATION_LINK_FAILED";
